<template>
    <div>
        <div
            id="slot-hover"
            class="day-popup tooltip-container visible hovered"
            :style="style"
            v-if="show"
        >
            <div class="tooltip-slot">
                <div class="person-popup__buttons">
                    <button
                        class="btn"
                        @click="editslot()"
                        :title="trans('Edit')"
                        data-toggle="tooltip"
                        data-placement="left"
                    >
                        <i class="icofont-ui-edit"></i>
                    </button>
                    <!--
                                <button
                                    class="btn btn-hover-warning"
                                    v-if="item.slot.persons.length"
                                    @click="confirm(clear)"
                                    :title="trans('Detach person')"
                                    data-toggle="tooltip"
                                    data-placement="left"
                                >
                                    <i class="icofont-close-circled"></i>
                                </button> -->

                    <button
                        class="btn btn-hover-danger"
                        @click="openConfirmationModalComponent()"
                        :title="trans('Delete')"
                        data-toggle="tooltip"
                        data-placement="left"
                    >
                        <i class="icofont-ui-delete"></i>
                    </button>
                </div>
                <div class="person-popup__details">
                    <!-- &lt;!&ndash; FIXME: only show this warning if there is one &ndash;&gt;
                <template v-if="false">
                    <div class="alert alert-warning">
                        Warning!

                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </template> -->
                    <table v-if="slot">
                        <tr>
                            <td>{{ trans('Client') }}:</td>
                            <td
                                v-if="slot.client"
                                :class="{
                                    'font-italic': slot.client.deleted_at,
                                }"
                            >
                                <template v-if="slot.client.type === 'company'">
                                    <i class="icofont-building-alt"></i>
                                </template>
                                <template v-else-if="slot.client.type === 'contact'">
                                    <i class="icofont-user-alt-3"></i>
                                </template>
                                {{ slot.client.title }}
                            </td>
                            <td v-else></td>
                        </tr>

                        <tr>
                            <td>{{ trans('Project') }}:</td>
                            <td
                                v-if="slot.project"
                                :class="{
                                    'font-italic': slot.project.deleted_at,
                                }"
                            >
                                {{ slot.project.title }}
                            </td>
                            <td v-else></td>
                        </tr>

                        <tr v-if="slot.project && slot.project.description">
                            <td>{{ trans('Project description') }}:</td>
                            <td class="text-break">
                                <span v-if="!readMoreProjectDescription">
                                    <vue-markdown
                                        class="description-style"
                                        :source="slot.project.description.slice(0, 35)"
                                    ></vue-markdown>
                                    <button
                                        v-if="slot.project.description.length > 35"
                                        class="btn-link"
                                        style="font-size: 10px; float: right"
                                        @click="readMoreProjectDescription = true"
                                    >
                                        {{ trans('show more') }}
                                    </button>
                                </span>
                                <span v-if="readMoreProjectDescription">
                                    <vue-markdown
                                        class="description-style"
                                        :source="slot.project.description"
                                    ></vue-markdown>
                                    <button
                                        class="btn-link"
                                        style="font-size: 10px; float: right"
                                        @click="readMoreProjectDescription = false"
                                    >
                                        {{ trans('show less') }}
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ trans('Task') }}:</td>
                            <td
                                :class="{
                                    'font-italic': slot.task_deleted_at,
                                }"
                            >
                                {{ slot.task_title }}
                            </td>
                        </tr>
                        <tr v-if="slot.task_description">
                            <td>{{ trans('Task description') }}:</td>
                            <td class="text-break">
                                <span v-if="!readMoreTaskDescription">
                                    <vue-markdown
                                        class="description-style"
                                        :source="slot.task_description.slice(0, 35)"
                                    ></vue-markdown>
                                    <button
                                        v-if="slot.task_description.length > 35"
                                        class="btn-link"
                                        style="font-size: 10px; float: right"
                                        @click="readMoreTaskDescription = true"
                                    >
                                        {{ trans('show more') }}
                                    </button>
                                </span>
                                <span v-if="readMoreTaskDescription">
                                    <vue-markdown
                                        class="description-style"
                                        :source="slot.task_description"
                                    ></vue-markdown>
                                    <button
                                        class="btn-link"
                                        style="font-size: 10px; float: right"
                                        @click="readMoreTaskDescription = false"
                                    >
                                        {{ trans('show less') }}
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ trans('Status') }}:</td>
                            <td
                                class="d-flex align-items-center"
                                :class="{
                                    'font-italic': slot.task_status_deleted_at,
                                }"
                            >
                                <span
                                    class="badge-round round-sm"
                                    :style="{ backgroundColor: slot.task_status_color }"
                                ></span
                                >{{ slot.task_status }}
                            </td>
                        </tr>
                    </table>

                    <table class="mt-2">
                        <tr>
                            <td>{{ trans('Period') }}:</td>
                            <td>
                                {{ slot.date_start }}
                                &mdash;
                                {{ slot.date_end }}
                            </td>
                        </tr>
                        <tr>
                            <td>{{ trans('From') }} - {{ trans('To') }}:</td>
                            <td>{{ slot.time_start }} &mdash; {{ slot.time_end }}</td>
                        </tr>
                        <tr>
                            <td>{{ trans('Employee') }}:</td>
                            <td>
                                <div v-for="team of slot.assigned_teams">
                                    {{ team.title }}

                                    <div v-for="person of team.assignees">
                                        -
                                        <span
                                            :class="{
                                                'font-italic': person.deleted_at,
                                            }"
                                        >
                                            {{ person.last_name }} {{ person.first_name }}
                                        </span>
                                    </div>
                                </div>
                                <div
                                    v-for="person of slot.assigned_persons"
                                    :class="{
                                        'font-italic': person.deleted_at,
                                    }"
                                >
                                    {{ person.last_name }} {{ person.first_name }}
                                </div>
                            </td>
                        </tr>
                    </table>

                    <div class="task-work-log-container">
                        <task-work-log-progress-bar
                            :task-id="slot.task_id"
                        ></task-work-log-progress-bar>
                    </div>
                </div>
            </div>
        </div>
        <confirmation-modal-component
            v-if="confirmationModal.active"
            :body="confirmationModal.body"
            :subtitle="confirmationModal.subtitle"
            @close="confirmationModal.active = false"
            @succes="deleteSlot()"
        ></confirmation-modal-component>
        <update-repeated-slots-component
            v-if="updateRepeatedSlotsModal.active"
            :slot_id="updateRepeatedSlotsModal.slot_id"
            :all_update_option="updateRepeatedSlotsModal.all_update_option"
            @close="updateRepeatedSlotsModal.active = false"
            @update="deleteRepeatedSlots"
        ></update-repeated-slots-component>
    </div>
</template>

<script>
import { emitter } from '../../../plugins/Mitt';
import { mapActions, mapState } from 'vuex';

import TaskWorkLogProgressBar from '../../schedule/widgets/TaskWorkLogProgressBar.vue';
import UpdateRepeatedSlotsComponent from '../../schedule/widgets/UpdateRepeatedSlotsComponent';
import VueMarkdown from "vue-markdown-render";

let showHoverInfoTimer;
const CancelToken = axios.CancelToken;
let cancel;

export default {
    components: {
        VueMarkdown,
        TaskWorkLogProgressBar,
        UpdateRepeatedSlotsComponent,
    },
    data() {
        return {
            slotId: null,
            loading: false,
            show: false,
            posX: 0,
            posY: 0,
            slot: {},
            isProgressBarVisible: false,
            confirmationModal: {
                active: false,
                body: '',
                header: '',
                slot: null,
            },
            updateRepeatedSlotsModal: {
                active: false,
                slot_id: null,
                all_update_option: false,
            },
            optionConfirmedRepeatedSlotsInModal: false,
            updateRepeatedSlotSetting: '',
            readMoreProjectDescription: false,
            readMoreTaskDescription: false,
        };
    },
    computed: {
        ...mapState('planning', ['mode']),
        style() {
            return {
                top: this.posY + 'px',
                left: this.posX + 'px',
            };
        },
    },
    methods: {
        ...mapActions('planning', ['requestItemSlots']),
        showHoverInfo(event) {
            const targetPosition = event.target.getBoundingClientRect();
            this.posX = targetPosition.left + 20;
            this.posY = targetPosition.bottom;
            this.show = true;
            this.calculate(targetPosition);
        },
        editslot() {
            this.show = false;
            emitter.emit('open-planning-form', {
                slotId: this.slotId,
            });
        },
        deleteRepeatedSlots(value) {
            this.updateRepeatedSlotSetting = value;
            this.optionConfirmedRepeatedSlotsInModal = true;
            this.updateRepeatedSlotsModal.active = false;
            this.deleteSlot();
        },
        deleteSlot() {
            this.confirmationModal.active = false;

            // Repeated slots
            if (this.slot.repeated_settings_id && !this.optionConfirmedRepeatedSlotsInModal) {
                this.updateRepeatedSlotsModal.active = true;
                return;
            }

            const slotId = this.slotId;
            this.slotId = null;
            this.show = false;

            const url = route('planning.delete-slots', slotId);
            axios
                .delete(url, {
                    data: {
                        updateRepeatedSlotSetting: this.updateRepeatedSlotSetting,
                    },
                })
                .then((response) => {
                    emitter.emit('slot-deleted');
                    switch (this.mode) {
                        case 'project':
                            const taskIds = response.data.taskIds;
                            this.requestItemSlots({ itemsIds: taskIds });
                            break;
                        case 'person':
                            const personIds = response.data.personIds;
                            this.requestItemSlots({ itemsIds: personIds });
                            break;
                        case 'equipment':
                            const equipmentIds = response.data.equipmentIds;
                            this.requestItemSlots({ itemsIds: equipmentIds });
                            break;
                        case 'team':
                            const teamIds = response.data.teamIds;
                            this.requestItemSlots({ itemsIds: teamIds });
                            break;
                    }
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        const errorMessage = trans("You don't have rights for this project");
                        emitter.emit('hide-slot-hover-info');
                        emitter.emit('hide-day-hover-info');
                        emitter.emit('show-message-modal', {
                            messageHtml: errorMessage,
                        });
                    }
                });

            if (this.optionConfirmedRepeatedSlotsInModal) {
                this.optionConfirmedRepeatedSlotsInModal = false;
                this.updateRepeatedSlotSetting = null;
            }
        },
        getInfoForSlot(event) {
            const url = route('planning.get-slot-data-for-hover-component', this.slotId);
            axios
                .get(url, {
                    cancelToken: new CancelToken(function executor(c) {
                        // An executor function receives a cancel function as a parameter
                        cancel = c;
                    }),
                })
                .then((response) => {
                    this.slot = response.data;
                    this.showHoverInfo(event);
                })
                .catch(() => {});
        },
        openConfirmationModalComponent() {
            this.show = false;
            this.confirmationModal.active = true;
            this.confirmationModal.subtitle = trans('Watch out');
            this.confirmationModal.body = trans('Are you sure you want to delete this slot?');
            this.confirmationModal.slot = this.slotId;
        },
        calculate(targetPosition) {
            this.$nextTick(() => {
                const box = document.querySelector('.day-popup');
                const rect = box.getBoundingClientRect();
                const isInViewport =
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

                if (!isInViewport) {
                    this.posX = targetPosition.left + 20;
                    this.posY = targetPosition.top;
                    if (rect.right > (window.innerWidth || document.documentElement.clientWidth)) {
                        box.classList.add('popup-side-left');
                        this.posY = targetPosition.top + 20;
                    } else {
                        box.classList.add('popup-side-top');
                    }
                }
            });
        },
    },
    mounted() {
        emitter.on('show-slot-hover-info', ({ slotId, event }) => {
            if (this.slotId === slotId) {
                return;
            }
            this.show = false;
            this.slotId = slotId;
            clearTimeout(showHoverInfoTimer);
            showHoverInfoTimer = setTimeout(() => this.getInfoForSlot(event), 1000);
        });
        emitter.on('hide-slot-hover-info', () => {
            clearTimeout(showHoverInfoTimer);
            cancel && cancel();
            this.slotId = null;
            this.show = false;
            this.readMoreTaskDescription = false;
            this.readMoreProjectDescription = false;
        });
        this.isProgressBarVisible = true;
    },
    beforeUnmount() {
        cancel && cancel();
        this.isProgressBarVisible = false;
    },
};
</script>
<style lang="scss">
.person-popup__details {
    max-height: 450px;
    overflow-y: scroll;
}
</style>
